import React from 'react';
import { createRecoilKey } from '../helpers/createKey';
import { atom, useRecoilCallback, useRecoilValue } from 'recoil';
import { PaylerModal } from '@payler/ui-components';
import { useTranslation } from 'react-i18next';
import { NewReportSBPForm } from '../forms/NewReportForm/NewReportSBPForm';
import { NewReportSBPPayoutForm } from '../forms/NewReportForm/NewReportSBPPayoutForm';
import { chakra, useToast } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { useToasts } from '../hooks/use-toasts';

const newReportModalOpenedAtom = atom({
  key: createRecoilKey('NewReportModalSBP'),
  default: false,
});

export const useShowNewReportModal = () =>
  useRecoilCallback(
    ({ set }) =>
      () => {
        set(newReportModalOpenedAtom, true);
      },
    [],
  );

export const useCloseNewReportModal = () =>
  useRecoilCallback(
    ({ set }) =>
      () => {
        set(newReportModalOpenedAtom, false);
      },
    [],
  );

export const NewReportModalSBP = () => {
  const { t } = useTranslation(['reports']);
  const open = useRecoilValue(newReportModalOpenedAtom);
  const close = useCloseNewReportModal();
  const navigate = useNavigate();
  const toast = useToast();
  const toasts = useToasts();

  const handleLinkClick = () => {
    toast.closeAll();
    navigate('/reports');
  };

  const handleSubmit = () => {
    toasts.success(
      <chakra.a
        onClick={handleLinkClick}
        textDecoration="underline"
        cursor="pointer"
      >
        {t('reports:goToReports')}
      </chakra.a>,
      t('reports:reportCreated'),
    );
    close();
  };

  if (!open) return null;

  return (
    <PaylerModal close={close} open={open} title={t('reports:newReport')}>
      <NewReportSBPForm onSubmit={handleSubmit} />
    </PaylerModal>
  );
};

export const  NewReportModalSBPPayout = () => {
  const { t } = useTranslation(['reports']);
  const open = useRecoilValue(newReportModalOpenedAtom);
  const close = useCloseNewReportModal();
  const navigate = useNavigate();
  const toast = useToast();
  const toasts = useToasts();

  const handleLinkClick = () => {
    toast.closeAll();
    navigate('/reports');
  };

  const handleSubmit = () => {
    toasts.success(
      <chakra.a
        onClick={handleLinkClick}
        textDecoration="underline"
        cursor="pointer"
      >
        {t('reports:goToReports')}
      </chakra.a>,
      t('reports:reportCreated'),
    );
    close();
  };

  return (
    <PaylerModal close={close} open={open} title={t('reports:newReport')}>
      <NewReportSBPPayoutForm onSubmit={handleSubmit}/>
    </PaylerModal>
  );
}
